import React from "react";
import { Modal, Text, createStyles } from "@mantine/core";
import { ReactComponent as SuccessIcon } from "../../../../common/assets/green-checkmark.svg";

type BlockedDatesAppliedProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setIsCreateNew: (isOpen: boolean) => void;
  lang: {
    title: string;
    subtitle: string;
    description: string;
  };
};

export const useStyles = createStyles(() => ({
  ".mantine-Modal-header ": {
    "button svg": {
      height: "24px",
      width: "24px",
    },
  },
}));

export const BlockedDatesAppliedSuccessfully: React.FC<
  BlockedDatesAppliedProps
> = ({ isOpen, setIsOpen, setIsCreateNew, lang }) => {
  const { classes } = useStyles();
  return (
    <Modal
      className={classes[".mantine-Modal-header "]}
      size="lg"
      centered
      opened={isOpen}
      onClose={() => {
        setIsOpen(false);
        setIsCreateNew(false);
        window.location.reload();
      }}
      closeOnClickOutside
      styles={{
        header: {
          backgroundColor: "#ffffff",
          padding: "40px 40px 0 0",
        },
        body: {
          paddingTop: "0",
        },
        close: {
          borderColor: "white",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          width: "400px",
          margin: "30px auto",
        }}
      >
        <div>
          <SuccessIcon />
        </div>
        <Text
          size="xl"
          style={{
            marginTop: "30px",
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "24.59px",
          }}
        >
          {lang.title}
        </Text>
        <Text size="xs" weight={400} mt={12}>
          {lang.subtitle}
        </Text>
        <Text size="xs" weight={400} mt={12}>
          {lang.description}
        </Text>
      </div>
    </Modal>
  );
};
